import { render, staticRenderFns } from "./UpdateTitleDialog.vue?vue&type=template&id=10f828f4&scoped=true&"
import script from "./UpdateTitleDialog.js?vue&type=script&lang=js&"
export * from "./UpdateTitleDialog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f828f4",
  null
  
)

export default component.exports